import { type CustomDateTimePreset } from '@synqo/frontend-component-library';

/**
 * The calendar day `months` after `date`, at local midnight; a day missing in the target month becomes its last day.
 *
 * @ai-generated 2026-10-08T06:54:24+00:00 by malte.ulfers@tngtech.com using claude-opus-5-5
 */
export function monthsAfter(date: Date, months: number): Date {
    const result = new Date(date.getFullYear(), date.getMonth() + months, date.getDate());
    if (result.getDate() !== date.getDate()) {
        result.setDate(0);
    }
    return result;
}

export const secretExpiryPresets: readonly CustomDateTimePreset[] = [
    { label: '6 Monate', getValue: () => monthsAfter(new Date(), 6) },
    { label: '1 Jahr', getValue: () => monthsAfter(new Date(), 12) },
    { label: '2 Jahre', getValue: () => monthsAfter(new Date(), 24) },
];
